import { cn } from '~/utils/cn';

import { Text } from '../../atoms/Text/view';

export type FinancialStatus = 'healthy' | 'attention' | 'moderate' | 'critical';

interface PropsStatusChip {
  status: FinancialStatus;
  size?: 'sm' | 'md';
  className?: string;
}

const COPY: Record<FinancialStatus, string> = {
  healthy: 'Situação saudável',
  attention: 'Atenção',
  moderate: 'Risco moderado',
  critical: 'Situação crítica',
};

const STYLE: Record<FinancialStatus, { wrap: string; dot: string; text: string }> = {
  healthy: {
    wrap: 'bg-success-01 border-success-02',
    dot: 'bg-success-04',
    text: 'color-success-06',
  },
  attention: {
    wrap: 'bg-alert-01 border-alert-02',
    dot: 'bg-alert-04',
    text: 'color-alert-06',
  },
  moderate: {
    wrap: 'bg-alert-02 border-alert-03',
    dot: 'bg-alert-05',
    text: 'color-alert-07',
  },
  critical: {
    wrap: 'bg-warning-01 border-warning-02',
    dot: 'bg-warning-04',
    text: 'color-warning-06',
  },
};

export default function StatusChip({ status, size = 'md', className }: PropsStatusChip) {
  const s = STYLE[status];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-quark rounded-full border',
        size === 'sm' ? 'px-smaller py-[3px]' : 'px-smaller py-quark',
        s.wrap,
        className,
      )}
    >
      <span className={cn('w-[7px] h-[7px] rounded-full', s.dot)} />
      <Text
        className={cn(
          'font-semibold tracking-wide',
          size === 'sm' ? 'text-captionMD' : 'text-captionLG',
          s.text,
        )}
      >
        {COPY[status]}
      </Text>
    </span>
  );
}
